import 'angular:locale/data:es';
import 'angular:locale/data:se';
import 'angular:locale/data:de';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
